import React, {useMemo} from 'react';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import {AgentEditSceneCore} from './AgentEditSceneCore';
import {useAgentUrlParameters, useLinkedValueSearchPageConfig} from './hooks';

export const AgentEditScene: React.FC = () => {
  const codelistIds = useAllCodeListIds();
  const thesaurusIds = useAllThesaurusIds();
  const {agentId} = useAgentUrlParameters();

  const linkedValueSearchPageConfig = useLinkedValueSearchPageConfig(agentId);
  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore(
    {
      canToggleFullWidth: true,
    },
    linkedValueSearchPageConfig,
  );
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );

  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <SceneExtensionsContext.Provider value={sceneExtensionContext}>
          <AgentEditSceneCore />
        </SceneExtensionsContext.Provider>
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
